<template>
  <div class="image-container set-full-height">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-sm-offset-2" align="left" style="margin-bottom: 25px">
          <button class="btn btn-danger" @click="blackMenu" style="color: red">กลับสู่หน้า Home</button>
        </div>
        <div class="col-sm-12" style="background-color:#327339">

          <h3 align="center" style="color:#000; font-family:Prompt">ระบบทำบัตรออนไลน์ คณะแพทยศาสตร์
            ม.สงขลานครินทร์&nbsp;&nbsp;<a href="index.html" style="color:#000"><i class="ti-home"></i></a>
          </h3>
          <!--      Wizard container        -->
          <transition name="slide-fade">
            <div class="wizard-container" v-show="!ShowDetails">

              <div class="card wizard-card" data-color="orange" id="wizardProfile">
                <div action="" method="">
                  <!--        You can switch " data-color="orange" "  with one of the next bright colors: "blue", "green", "orange", "red", "azure"          -->

                  <div class="wizard-header" align="center">
                    <div align="right" style="">{{ nameAdmin }} {{ surnameAdmin }} {{ depart }}</div>
                    <div class="row" style="margin-top:-20px;">
                      <div class="col-sm-12">
                        <h4 style="color:#000; font-family:Prompt"><u>ข้อมูลการขอทำบัตร</u>
                        </h4>

                        <v-container
                            id="scroll-target"
                            style="max-height: 800px"
                            class="overflow-y-auto"
                        >
                          <v-row
                              v-scroll:#scroll-target="onScroll"
                              align="center"
                              justify="center"
                              style="height: 100%"
                          >
                            <v-card>
                              <v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="ค้นหา"
                                    single-line
                                    hide-details
                                ></v-text-field>
                              </v-card-title>
                              <v-data-table
                                  :headers="columns"
                                  :items="rows"
                                  item-key="name"
                                  class="elevation-1"
                                  :search="search"
                              >
                                <template v-slot:item.url_display="{ item }">
                                  <img :src="ConnectionName + '/rest/files/' + item.url_display"
                                       width="130" height="150">
                                </template>
                                <template v-slot:item.Type="{item}">
                                  <td style="color:#000; font-family:Prompt; font-size:12px;"
                                      align="left">{{ item.Type }}
                                  </td>
                                </template>
                                <template v-slot:item.FullName="{ item }">
                                  <td style="color:#000; font-family:Prompt; font-size:12px;"
                                      align="left">{{ item.FullName }}
                                  </td>
                                </template>
                                <template v-slot:item.CardRequest="{ item }">
                                  <v-chip color="#00bbff"
                                          v-if="item.request_wish_id == '1'">
                                    {{ item.CardRequest }}
                                  </v-chip>
                                  <v-chip color="#985f0d"
                                          v-if="item.request_wish_id == '2'">
                                    {{ item.CardRequest }}
                                  </v-chip>
                                </template>
                                <template v-slot:item.DateShow="{ item }">
                                  <td style="color:#000; font-family:Prompt; font-size:12px;"
                                      align="left">{{ item.DateShow }}
                                  </td>
                                </template>
                                <template v-slot:item.status_name="{ item }">
                                  <td style="color:blue; font-family:Prompt; font-size:12px;"
                                      align="left"
                                      v-if="item.status_id == '1' || item.status_id == '0'">
                                    {{ item.status_name }}
                                  </td>
                                  <td style="color:#3c763d; font-family:Prompt; font-size:12px;"
                                      align="left" v-if="item.status_id == '2'">
                                    {{ item.status_name }}
                                  </td>
                                  <td style="color:rgba(185,11,19,0.99); font-family:Prompt; font-size:12px;"
                                      align="left" v-if="item.status_id == '3'">
                                    {{ item.status_name }}
                                  </td>
                                  <td style="color:#5e5e5e; font-family:Prompt; font-size:12px;"
                                      align="left" v-if="item.status_id == '4'">
                                    {{ item.status_name }}
                                  </td>
                                  <td style="color:rgba(148,24,185,0.99); font-family:Prompt; font-size:12px;"
                                      align="left" v-if="item.status_id == '5'">
                                    {{ item.status_name }}
                                  </td>
                                  <td style="color:#afb42b; font-family:Prompt; font-size:12px;"
                                      align="left" v-if="item.status_id == '6'">
                                    {{ item.status_name }}
                                  </td>
                                </template>
                                <template v-slot:item.action="{ item }">
                                  <td style="color:#000; font-family:Prompt; font-size:12px;"
                                      align="left">
                                    <button class="btn btn-info"
                                            style="font-size: 12px"
                                            @click="showDetailsFunc(item)">
                                      รายละเอียด
                                    </button>
                                  </td>
                                </template>
                                <template v-slot:expanded-item="{ columns, item }">
                                  <td :colspan="5">More info about {{ item.id }}</td>
                                </template>
                              </v-data-table>
                            </v-card>
                          </v-row>
                        </v-container>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <transition name="slide-fade2">
            <div class="wizard-container" v-if="ShowDetails">

              <div class="card wizard-card" data-color="orange" id="wizardProfile">
                <form action="" method="">
                  <!--        You can switch " data-color="orange" "  with one of the next bright colors: "blue", "green", "orange", "red", "azure"          -->

                  <div class="wizard-header text-center">
                    <div align="right" style="">{{ nameAdmin }} {{ surnameAdmin }} {{ depart }}</div>
                    <div class="tab-content" style="margin-top:-20px;">
                      <div class="row">
                        <div align="left">
                          <button class="btn btn-warning" @click="showDetailsFunc">
                            ย้อนกลับ
                          </button>
                        </div>
                        <div class="col-sm-12 col-sm-offset-0">
                          <h4 style="color:#000; font-family:Prompt"><u>ข้อมูลการขอทำบัตร</u>
                          </h4>
                          <div class="tab-content">
                            <div class="row">

                              <div class="row">
                                <div class="col-sm-12"><br>

                                  <h5 class="info-text"
                                      style="font-family:Prompt; text-align:center;background-color:#327339;color:#fff">
                                    &nbsp;&nbsp;ตัวอย่างบัตร</h5>
                                </div>
                                <div class="col-sm-6"
                                     style="margin-top: 25px;height: fit-content;width: 100%"
                                     align="center">
                                  <div class="form-group"
                                       style="text-align:center;height: 435px;width: fit-content">
                                    <img src="../assets/img/card2.jpg" width="278"
                                         height="440">
                                    <div style="top: -302px;position: relative;left: -39px;width: 162px"
                                         align="right">
                                      <span>{{ perid }}</span>
                                    </div>
                                    <div
                                        style="top: -287px;position: relative;width: 124px;height: fit-content;float: left;margin: 0px;padding: 0px"
                                        align="right">
                                      <span>{{ hn }}</span>
                                    </div>
                                    <img :src="ImagePerson" width="130" height="150"
                                         :style="ShowPicCss">
                                    <div style="top: -342px;position: relative;left: -8px;width: 100%"
                                         align="right">
                                      <span style="font-weight: bold">{{ nameTh }} {{ surnameTh }}</span>
                                    </div>
                                    <div style="top: -342px;position: relative;left: -8px;width: 100%"
                                         align="right">
                                      <span style="font-style: italic">{{ nameEn }} {{ surnameEn }}</span>
                                    </div>
                                    <div style="top: -342px;position: relative;left: -8px;width: 100%"
                                         align="right">
                                      <span style="font-weight: bold">{{ position }}</span>
                                    </div>
                                    <div v-if="depart != null">
                                      <div style="top: -342px;position: relative;left: -8px;width: 100%"
                                           align="right" v-if="depart.indexOf(' ') >= 0">
                                        <span style="font-weight: bold">{{ depart.split(' ')[0] }}</span>
                                      </div>
                                      <div style="top: -342px;position: relative;left: -8px;width: 100%"
                                           align="right" v-else>
                                        <span style="font-weight: bold">{{ depart }}</span>
                                      </div>
                                    </div>
                                    <div style="top: -308px;position: relative;width: fit-content"
                                         align="left">
                                      <span
                                          style="padding-left: 112px;font-weight: bold">{{
                                          Date_Expire | DateToThaiManageCard
                                        }}</span>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-sm-6"
                                     style="margin-top: 25px;width: 100%"
                                     align="center">
                                  <div class="form-group backimg"
                                       style="text-align:center">
                                    <img src="../assets/img/card1.jpg" width="278"
                                         height="440">

                                  </div>
                                </div>


                                <div class="col-sm-12">

                                  <h5 class="info-text"
                                      style="font-family:Prompt; text-align:center;background-color:#327339; color:#fff">
                                    &nbsp;&nbsp;1. ข้อมูลส่วนตัว(ญาติ)</h5>
                                </div>

                                <div class="col-sm-5 col-sm-offset-1">
                                  <div class="form-group">
                                    <label>รหัสบุคลากร</label>
                                    <p class="form-control" id="perid"
                                       style="background-color: #dcfbdf">
                                      {{ perid }}</p>
                                  </div>
                                </div>


                                <div class="col-sm-5">
                                  <div class="form-group">
                                    <label>ชื่อ(ภาษาไทย)</label>
                                    <p class="form-control" id="nameTh"
                                       style="background-color: #dcfbdf">
                                      {{ nameTh }}</p>
                                  </div>
                                </div>
                                <div class="col-sm-5 col-sm-offset-1">
                                  <div class="form-group">
                                    <label>นามสกุล(ภาษาไทย)</label>
                                    <p class="form-control" id="surnameTh"
                                       style="background-color: #dcfbdf">
                                      {{ surnameTh }}</p>
                                  </div>
                                </div>

                                <div class="col-sm-5">
                                  <div class="form-group">
                                    <label>เลขที่บัตรประชาชน</label><br>
                                    <p class="form-control" id="idcard"
                                       style="background-color: #dcfbdf">
                                      {{ idcard }}</p>
                                  </div>
                                </div>
                                <div class="col-sm-5 col-sm-offset-1">
                                  <div class="form-group">
                                    <label>ชื่อ(ภาษาอังกฤษ)</label>
                                    <p class="form-control" id="nameEn"
                                       style="background-color: #dcfbdf">
                                      {{ nameEn }}
                                    </p>
                                  </div>
                                </div>
                                <div class="col-sm-5">
                                  <div class="form-group">
                                    <label>นามสกุล(ภาษาอังกฤษ)</label>
                                    <p class="form-control" id="surnameEn"
                                       style="background-color: #dcfbdf">
                                      {{ surnameEn }}
                                    </p>
                                  </div>
                                </div>
                                <div class="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
                                  <div class="form-group">
                                    <label>hn (เลขบัตรโรงพยาบาล)</label>
                                    <p class="form-control" id="hn"
                                       style="background-color: #dcfbdf">
                                      {{ hn }}
                                    </p>
                                  </div>
                                </div>
                                <div class="col-sm-5 col-sm-offset-1">
                                  <div class="form-group">
                                    <label>วัน/เดือน/ปี เกิด</label>
                                    <p class="form-control" id="brithDay"
                                       style="background-color: #dcfbdf">
                                      {{ brithDay }}</p>
                                  </div>
                                </div>

                                <div class="col-sm-5">
                                  <div class="form-group">
                                    <label>เพศ</label><br>
                                    <p class="form-control" id="gender"
                                       style="background-color: #dcfbdf">
                                      {{ gender }}</p>
                                  </div>
                                </div>

                                <div class="col-sm-10 col-sm-offset-1">
                                  <div class="form-group">
                                    <label>ภาควิชา/หน่วยงาน</label>
                                    <p class="form-control" id="depart"
                                       style="background-color: #dcfbdf">
                                      {{ depart }}</p>
                                  </div>
                                </div>

                                <div class="col-sm-5 col-sm-offset-1">
                                  <div class="form-group">
                                    <label>โทรศัพท์หน่วยงาน</label>
                                    <p class="form-control" id="phoneDepart"
                                       style="background-color: #dcfbdf">
                                      {{ phoneDepart }}</p>
                                  </div>
                                </div>

                                <div class="col-sm-5">
                                  <div class="form-group">
                                    <label>โทรศัพท์เคลื่อนที่</label><br>
                                    <p class="form-control" id="phoneMoblie"
                                       style="background-color: #dcfbdf">
                                      {{ phoneMoblie }}</p>
                                  </div>
                                </div>


                                <div class="col-sm-5 col-sm-offset-1">
                                  <div class="form-group">
                                    <label>โทรศัพท์บ้าน</label>
                                    <p class="form-control" id="phoneHome"
                                       style="background-color: #dcfbdf">
                                      {{ phoneHome }}</p>
                                  </div>
                                </div>

                                <div class="col-sm-5">
                                  <div class="form-group">
                                    <label>อีเมลล์</label><br>
                                    <p class="form-control" id="email"
                                       style="background-color: #dcfbdf">
                                      {{ email }}</p>
                                  </div>
                                </div>


                                <div class="col-sm-10 col-sm-offset-1">
                                  <div class="form-group">
                                    <label>ทีอยู่ตามทะเบียนบ้าน</label>
                                    <p class="form-control" id="address"
                                       style="background-color: #dcfbdf">
                                      {{ address }}</p>
                                  </div>
                                </div>


                              </div>
                              <div class="col-sm-12">
                                <h5 class="info-text"
                                    style="font-family:Prompt; text-align:center;background-color:#327339;color:#fff">
                                  &nbsp;&nbsp;2.
                                  ข้อมูลที่พักบุคลากร(ภายในคณะแพทยศาสตร์)</h5>
                              </div>

                              <div class="col-sm-5 col-sm-offset-1">
                                <div class="form-group">
                                  <label>หอพัก</label>
                                  <input type="text" class="form-control"
                                         v-model="dorm"
                                         id="dorm"
                                         placeholder="" value="-"
                                         style="background-color:#dcfbdf;color: white"
                                         disabled>
                                </div>
                              </div>

                              <div class="col-sm-5">
                                <div class="form-group">
                                  <label>ห้องพัก</label><br>
                                  <input type="text" class="form-control"
                                         v-model="dorm2"
                                         id="dorm2"
                                         placeholder="" value="-"
                                         style="background-color:#dcfbdf;color: white"
                                         disabled>
                                </div>
                              </div>
                            </div>


                            <div class="row">
                              <div class="col-sm-12"><br>

                                <h5 class="info-text"
                                    style="font-family:Prompt; text-align:center;background-color:#327339;color:#fff">
                                  &nbsp;&nbsp;หลักฐานประกอบการทำบัตรบุคลากร</h5>
                              </div>

                              <div class="col-sm-10 col-sm-offset-1" align="center">
                                <div class="form-group">
                                  <label>1) รูปถ่าย ขนาด 1 นิ้ว (หน้าตรง ไม่สวมหมวก
                                    ไม่สวมแว่นดำ)</label>
                                </div>
                                <img v-if="ImagePersonType" :src="ImagePerson"
                                     class="img-responsive"
                                     style="cursor: pointer"
                                     @click="ShowData(ImagePerson)"/>
                                <iframe v-if="pdfPersonType" :src="ImagePerson"
                                        style="width:400px; height:300px;"
                                        frameborder="0"
                                        @click="ShowData(ImagePerson)"></iframe>
                                <div v-if="pdfPersonType" align="center">
                                  <button class="btn btn-info"
                                          style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                          @click="ShowData(ImagePerson)">เปิด PDF
                                  </button>
                                </div>
                                <div class="form-group" style="margin-top: 10px">
                                  <label style="color: royalblue;cursor: pointer"
                                         @click.prevent="downloadItem">ดาวโหลดรูปภาพ</label>
                                </div>
                              </div>

                              <div class="col-sm-10 col-sm-offset-1" align="center"
                                   style="margin-top: 25px">
                                <div class="form-group">
                                  <label>2) ใบเสร็จรับเงิน งานคลัง
                                    คณะแพทยศาสตร์</label>
                                </div>
                                <img v-if="ImageRecriptType" :src="ImageRecript"
                                     class="img-responsive"
                                     style="cursor: pointer"
                                     @click="ShowData(ImageRecript)"/>
                                <iframe v-if="pdfRecriptType" :src="ImageRecript"
                                        style="width:400px; height:300px;"
                                        frameborder="0"
                                        @click="ShowData(ImageRecript)"></iframe>
                                <div v-if="pdfRecriptType" align="center">
                                  <button class="btn btn-info"
                                          style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                          @click="ShowData(ImageRecript)">เปิด PDF
                                  </button>
                                </div>
                              </div>

                            </div>

                            <div class="row"
                                 v-if="CardObj.status_id == '3' || CardObj.status_id == '5'">
                              <div class="col-sm-12"><br>
                                <div class="row" align="center">
                                  <div class="col-sm-12"><br>

                                    <h5 class="info-text"
                                        style="font-family:Prompt; text-align:center;background-color:#327339;color:#fff">
                                      &nbsp;&nbsp;สถานะบัตร</h5>

                                    <div class="row">
                                      <div class="col-md-2"></div>
                                      <div class="col-md-8">
                                        <span
                                            style="margin-left: 20px;font-size: 18px;color: #8a6d3b">( {{
                                            CardObj.status_name
                                          }} )</span>
                                      </div>
                                      <div class="col-md-2"></div>
                                    </div>

                                    <div align="center" style="margin-top: 25px">
                                      <label style="margin-bottom: 15px">เหตุผล</label>
                                      <div>
                                                                                <textarea type="text"
                                                                                          v-model="ApproveDetail"
                                                                                          style="width: 300px;height: 100px"
                                                                                          disabled/>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>

                              <div align="left" style="margin-left: 30px">
                                <button class="btn btn-warning"
                                        @click="showDetailsFunc">
                                  ย้อนกลับ
                                </button>
                              </div>
                            </div>

                            <!--                            รอจ่ายบัตร-->
                            <!--                            <div class="row" v-if="CardObj.status_id == '4'">
                                                          <div class="col-sm-12"><br>

                                                            <h5 class="info-text"
                                                                style="font-family:Prompt; text-align:left;background-color:#fe1800;color:#fff">
                                                              &nbsp;&nbsp;รอจ่ายบัตร</h5>

                                                            <div align="center" style="margin-top: 25px">
                                                              <button class="btn btn-success" @click="PayCard">
                                                                จ่ายบัตร
                                                              </button>
                                                            </div>

                                                            <div align="left" style="margin-left: 30px">
                                                              <button class="btn btn-warning"
                                                                      @click="showDetailsFunc">
                                                                ย้อนกลับ
                                                              </button>
                                                            </div>

                                                          </div>
                                                        </div>-->

                            <div class="row">
                              <div class="col-sm-12"><br>

                                <h5 class="info-text"
                                    style="font-family:Prompt; text-align:left;background-color:#327339;color:#fff">
                                  &nbsp;&nbsp;อนุมัติการขอทำบัตร</h5>
                                <v-alert
                                    dense
                                    outlined
                                    type="error"
                                    v-if="CardObj.status_id == '3'"
                                >
                                  ไม่อนุมัติทำบัตร : เหตุผล {{ ApproveDetail }}
                                </v-alert>
                                <v-alert
                                    dense
                                    outlined
                                    type="success"
                                    v-else-if="CardObj.status_id == '2'"
                                >
                                  อนุมัติทำบัตร
                                </v-alert>
                                <v-alert
                                    dense
                                    outlined
                                    type="success"
                                    color="#78909C"
                                    v-else-if="CardObj.status_id == '4'"
                                >
                                  พิมพ์บัตร
                                </v-alert>
                                <v-alert
                                    dense
                                    outlined
                                    type="success"
                                    color="#00C853"
                                    v-else-if="CardObj.status_id == '5'"
                                >
                                  จ่ายบัตร
                                </v-alert>
                                <v-alert
                                    dense
                                    outlined
                                    type="warning"
                                    v-else
                                    color="#1976D2"
                                >
                                  ยื่นคำขอทำบัตร
                                </v-alert>
                                <div class="row">
                                  <div class="col-md-12">
                                    <v-radio-group v-model="status" row>
                                      <v-radio label="ยื่นคำขอทำบัตร" value="0"></v-radio>
                                      <v-radio label="แก้ไข" value="6"></v-radio>
                                      <v-radio label="อนุมัติ" value="2"></v-radio>
                                      <v-radio label="ไม่อนุมัติ" value="3"></v-radio>
                                      <v-radio label="พิมพ์บัตร" value="4"></v-radio>
                                      <v-radio label="จ่ายบัตร" value="5"></v-radio>
                                    </v-radio-group>
                                  </div>
                                </div>

                                <div align="center" style="margin-top: 25px" v-if="status == '3' || status == '6'">
                                  <label style="margin-bottom: 15px">เหตุผล</label>
                                  <div>
                                                        <textarea type="text" v-model="ApproveDetail"
                                                                  style="width: 600px;height: 100px;border: 2px silver solid"/>
                                  </div>
                                </div>

                                <div align="center" style="margin-top: 25px">
                                  <v-btn outlined color="primary"
                                         @click="ApproveData">บันทึก
                                  </v-btn>
                                </div>

                                <div align="left" style="margin-left: 30px">
                                  <button class="btn btn-warning" @click="showDetailsFunc">
                                    ย้อนกลับ
                                  </button>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </transition>

          <h5 align="center" style="color:#000; font-family:prompt;">ฝ่ายทรัพยากรมนุษย์
            อาคารบริหารคณะแพทยศาสตร์ ชั้น 4 คณะแพทยศาสตร์ มหาวิทยาลัยสงขลานครินทร์ <br>ติดต่อ 074-45-1140
            หรือ 074-45-1144 Email : person@medcine.psu.ac.th</h5>
        </div>
        <div class="col-sm-8 col-sm-offset-2" align="left" style="margin-top: 25px">
          <button class="btn btn-danger" @click="blackMenu" style="color: red"> กลับสู่หน้า Home</button>
        </div>
      </div><!-- end row -->
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import Vue from 'vue'
import ConstData from '../Const/Const'
import queryString from "query-string";

export default {
  name: "ManageCardHR",
  data: function () {
    return {
      ConnectionName: ConstData.ConnectionHost,
      ShowPicCss: '',
      search: '',
      singleExpand: false,
      columns: [
        {text: 'ภาพถ่าย', value: 'url_display'},
        {text: 'รหัสบุคลากร', value: 'perid'},
        {text: 'ชื่อ สกุล', value: 'FullName'},
        {text: 'บัตร', value: 'CardRequest'},
        {text: 'วันที่ยืนขอทำบัตร', value: 'DateShow'},
        {text: 'สถานะดำเนินการ', value: 'status_name'},
        {text: '', value: 'action'}
      ],
      rows: [],
      CardObj: null,
      ApproveDetail: '',
      Approve: true,
      CardDataPerson: [],
      ShowDetails: false,
      Date_Expire: '',
      perid: '',
      peridAdmin: '',
      idcard: '',
      nameAdmin: '',
      surnameAdmin: '',
      nameTh: '',
      nameEn: '',
      surnameTh: '',
      surnameEn: '',
      hn: '',
      brithDay: '',
      gender: '',
      depart: '',
      phoneDepart: '',
      phoneMoblie: '',
      phoneHome: '',
      position: '',
      email: '',
      address: '',
      dorm: '',
      dorm2: '',
      ImagePerson: '',
      ImageRecript: '',
      pdfPersonCopy: '',
      ImagePersonType: '',
      pdfPersonType: '',
      ImageRecriptType: '',
      pdfRecriptType: '',
      ImagePersonCopyType: '',
      pdfPersonCopyType: '',
      ImageHomeType: '',
      pdfHomeType: '',
      status: ''
    }
  },
  methods: {
    initFunc: function () {
      axios.post(ConstData.ConnectionHost + '/CardRegister/service.php', {
        queryName: 'PersonalDataByPerson',
        param: btoa(encodeURIComponent(JSON.stringify({
          perid: this.parseJwt(this.$cookies.get('access_token')).perid
        })))
      }).then(res => {
        if (res.data && res.data.staffData.length > 0) {
          this.peridAdmin = res.data.staffData[0].perid;
          this.nameAdmin = res.data.staffData[0].name
          this.surnameAdmin = res.data.staffData[0].surname
          this.depart = res.data.staffData[0].dep_name

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/depart_view/depart_types_id/1/PERID/' + this.peridAdmin).then(res => {
            if (res.data) {
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_types_id/1/?sort=id_DESC&limit=9999').then(res => {
                if (res.data) {
                  this.rows = []
                  if (res.data.length > 0) {
                    this.CardDataPerson = res.data
                  } else {
                    this.CardDataPerson.push(res.data)
                  }
                  this.CardDataPerson.forEach(function (item) {
                    item.Type = 'บุคลากร'
                    item.FullName = item.firstName + ' ' + item.lastName
                    if (item.request_wish_id == '1') {
                      item.CardRequest = 'ใหม่'
                    } else if (item.request_wish_id == '2') {
                      item.CardRequest = 'หาย/ชำรุด'
                    }
                    item.DateShow = Vue.filter('DateToThaiManageCard')(item.create_date.split(' ')[0])
                  })
                  this.rows = this.CardDataPerson
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่มีข้อมูลการทำบัตร'
                  })
                }
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'คุณไม่ได้รับสิทธิในการจัดการข้อมูล'
              })
              this.$router.push('/')
            }
          })
        }
      })
    },
    downloadItem() {
      axios.get(this.ImagePerson, {responseType: 'blob'})
          .then(response => {
            const blob = new Blob([response.data], {type: 'image/jpg'})
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = this.perid + '.jpg'
            link.click()
            URL.revokeObjectURL(link.href)

            /*var param = {
                'is_used': '0'
            }
            const headerAxios = {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms/id/' + ShopObj.id, param, headerAxios).then(res => {
                if (res.data.status) {

                }
            })*/

          }).catch(console.error)
    },
    onScroll(e) {
      this.scrollPosition = e.target.scrollTop
    },
    showDetailsFunc: function (Card_Data) {
      if (this.ShowDetails) {
        this.CardObj = null
        this.ShowDetails = false

        this.Date_Expire = ''
        this.perid = ''
        this.nameTh = ''
        this.surnameTh = ''
        this.brithDay = ''
        this.gender = ''
        this.depart = ''
        this.phoneDepart = ''
        this.phoneMoblie = ''
        this.phoneHome = ''
        this.email = ''
        this.address = ''
        this.dorm = ''
        this.dorm2 = ''
        this.ApproveDetail = ''
        this.ImagePerson = ''
        this.ImagePersonCopy = ''
        this.ImageRecript = ''
        this.ImageHome = ''
        this.status = ''
        this.$vuetify.goTo(this.scrollPosition)
      } else {
        this.$vuetify.goTo(200)
        this.ShowDetails = true
        this.Date_Expire = Card_Data.expire_date
        this.ApproveDetail = Card_Data.comment
        this.status = Card_Data.status_id

        this.CardObj = Card_Data
        axios.post(ConstData.ConnectionHost + '/CardRegister/service.php', {
          queryName: 'PersonalDataByPerson',
          param: btoa(encodeURIComponent(JSON.stringify({
            perid: Card_Data.perid
          })))
        }).then(res => {
          if (res.data && res.data.staffData.length > 0) {
            this.brithDay = this.convertMySQLDateToThai(res.data.staffData[0].birthdate)
            this.gender = res.data.staffData[0].sex == '2' ? 'ชาย' : 'หญิง'
            this.idcard = ""
            if (res.data.dormData != null && res.data.dormData.length > 0) {
              this.dorm = res.data.dormData[0].room_name
              this.dorm2 = res.data.dormData[0].dorm_name
            }
          }
        })
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact_view/request_id/' + Card_Data.id).then(contactV => {
          if (contactV.data) {
            this.phoneDepart = contactV.data[2].value
            this.phoneMoblie = contactV.data[3].value
            this.phoneHome = contactV.data[4].value
          }
        })

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment_view/person_id/' + Card_Data.person_id).then(res => {
          if (res.data) {


            switch (res.data[0].url.split('.')[1]) {
              case 'jpg':
              case 'jpeg':
              case 'gif':
              case 'bmp':
              case 'png':
                this.ImagePersonType = true
                this.pdfPersonType = false
                this.ImagePerson = ConstData.ConnectionHost + '/rest/files/' + res.data[0].url
                break
              case 'pdf':
                this.pdfPersonType = true
                this.ImagePersonType = false
                this.ImagePerson = ConstData.ConnectionHost + '/rest/files/' + res.data[0].url
                break
              default:
                this.ImagePersonType = false
                this.pdfPersonType = false
                this.ImagePerson = ''
                break
            }

            switch (res.data[2].url.split('.')[1]) {
              case 'jpg':
              case 'jpeg':
              case 'gif':
              case 'bmp':
              case 'png':
                this.ImageRecriptType = true
                this.pdfRecriptType = false
                this.ImageRecript = ConstData.ConnectionHost + '/rest/files/' + res.data[2].url
                break
              case 'pdf':
                this.pdfRecriptType = true
                this.ImageRecriptType = false
                this.ImageRecript = ConstData.ConnectionHost + '/rest/files/' + res.data[2].url
                break
              default:
                this.ImageRecriptType = false
                this.pdfRecriptType = false
                this.ImageRecript = ''
                break
            }
          }
        })


        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/person_view/request_id/' + Card_Data.id).then(res => {
          if (res.data) {
            this.perid = res.data.perid
            this.nameTh = res.data.firstName
            this.surnameTh = res.data.lastName
            this.nameEn = res.data.firstNameEn
            this.surnameEn = res.data.lastNameEn
            this.hn = res.data.hn
            this.idcard = res.data.citizenId
            this.depart = res.data.dep_name
            this.position = res.data.pos_name
            if ((this.depart == '' || this.depart == null) || (this.position == '' || this.position == null)) {
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/staff/perid/' + Card_Data.perid).then(res => {
                if (res.data) {
                  this.nameTh = res.data.name
                  this.surnameTh = res.data.surname
                  this.depart = res.data.dep_group_name
                  this.position = res.data.pos_name
                }
              })
            }

            if (this.hn == null || this.hn == '') {
              this.ShowPicCss = {
                "position": "relative",
                "top": "-345px",
                "object-fit": "contain",
                "left": "65px"
              }
            } else {
              this.ShowPicCss = {
                "position": "relative",
                "top": "-345px",
                "object-fit": "contain"
              }
            }
          }
        })

        /*axios.get(ConstData.ConnectionHostPerson + '/profile/' + Card_Data.perid + '/job-infomation').then(res => {
            if (res.data.data) {
                this.depart = res.data.data[res.data.data.length - 1][3];
                this.position = res.data.data[res.data.data.length - 1][1];
            }
        })*/
      }
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    ChooseApprove: function () {
      if (this.Approve) {
        this.Approve = false
      } else {
        this.Approve = true
      }
    },
    PayCard: function () {
      var param = {
        'status_id': '5'
      }
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request/id/' + this.CardObj.id, param, headerAxios).then(res => {
        if (res.data.status) {
          this.$swal.fire({
            icon: 'success',
            title: 'บันทึกข้อมูลสำเร็จ',
          })
          this.ShowDetails = false
          this.CardDataPerson = []
          this.rows = []
          this.initFunc()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ไม่สามารถยันทึกข้อมูลได้'
          })
        }
      });
    },
    ApproveData: function () {
      var param = {
        'status_id': this.status
      }
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request/id/' + this.CardObj.id, param, headerAxios).then(res => {
        if (res.data.status) {

          var param = {
            'comment': this.ApproveDetail
          }

          const headerAxios2 = {
            headers: {
              'Content-Type': 'application/json'
            }
          }

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request/id/' + this.CardObj.id, param, headerAxios2).then(resPut => {
            if (resPut.data.status) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/log_approve', {
                request_id: this.CardObj.id,
                status: this.status,
                comment: this.ApproveDetail,
                create_by: this.peridAdmin,
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'PUT'
                }
              })
              this.$swal.fire({
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ',
              })
              this.ShowDetails = false
              this.CardDataPerson = []
              this.rows = []
              this.initFunc()
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถยันทึกข้อมูลได้'
              })
            }
          })
        }
      })
    },
    blackMenu: function () {
      this.$router.push('/')
    },
    parseJwt: function (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    },
    convertMySQLDateToThai(mysqlDate) {
      // แยกปี เดือน วัน จากสตริงวันที่ MySQL
      const parts = mysqlDate.split("-");
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const day = parseInt(parts[2], 10);

      // สร้างวันที่ในรูปแบบของ JavaScript Date object
      // const date = new Date(year, month - 1, day);

      // รายการเดือนภาษาไทย
      const thaiMonths = [
        "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
        "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
      ];

      // แปลงเป็นรูปแบบวันที่ไทย
      const thaiDate = `${day} ${thaiMonths[month - 1]} ${year + 543}`; // เพิ่ม 543 เพื่อแปลงเป็นปีไทย

      return thaiDate;
    }
  },
  mounted() {
    axios.post(ConstData.ConnectionHost + '/saveSessions.php', queryString.stringify({
      session: 'https://medhr.medicine.psu.ac.th/CardRegister/#/ManageCardHR'
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    if (this.$cookies.get('access_token')) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$cookies.get('access_token');
      this.initFunc()
    } else {
      // this.$cookies.set('access_token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwZXJpZCI6IjQ2NzkyIiwibmFtZSI6Ilx1MGUxOFx1MGUyN1x1MGUzMVx1MGUwYVx1MGUwYVx1MGUzMVx1MGUyMiIsInN1cm5hbWUiOiJcdTBlMDhcdTBlMzFcdTBlMTlcdTBlMTdcdTBlMjNcdTBlMTdcdTBlMzRcdTBlMWVcdTBlMjJcdTBlNGMifQ.YTW8R5wDrEPUPv5HkvfewbiQKBwpF18o5ZBxwZPtk1o')

      this.$session.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/ManageCardHR')
      this.$cookies.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/ManageCardHR')
      window.location.href = ConstData.ConnectionHost + '/SingleSign/';
    }
  }
}
</script>

<style scoped>
* {
  font-family: Prompt;
}

.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade2-enter-active {
  transition: all .5s ease;
}

.slide-fade2-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade2-enter, .slide-fade2-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateY(10px);
  opacity: 0;
}

.v-data-table th {
  font-size: 16px;
}

.v-data-table td {
  font-size: 14px;
}
</style>
